/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import Bugsnag from '@bugsnag/js';
import {environment} from '../environments/environment';

// This service initializes Bugsnag and makes it available to the root module. Below are examples of some possible
// configurations, but only the api apiKey is required to get started.
Bugsnag.start({
  // get your own api key at bugsnag.com
  apiKey: 'b7def5fd2fd3bc63c891c91441c67282',

  // if you track deploys or use source maps, make sure to set the correct version.
  appVersion: environment.version,

  // Bugsnag can track the number of “sessions” that happen in your application, and calculate a crash rate for each
  // release. This defaults to false.
  autoTrackSessions: true,

  // defines the release stage for all events that occur in this app.
  releaseStage: environment.releaseStage,

  //  defines which release stages bugsnag should report. e.g. ignore staging errors.
  enabledReleaseStages: ['pre-release', 'release'],

  // because this is a demo app, below extends the default of 10 notifications per pageload. click away!
  maxEvents: 10,
});
